import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import { BsCheck2 } from 'react-icons/bs'
import moment from 'moment'

export default function StapPage4To2({ step, isComputer = 0 }) {
  const dataStep = step?.result ?? []
  const approve = step?.approve ?? {}
  const [detail_1, setDetail_1] = useState([])
  const [detail_2, setDetail_2] = useState([])
  const [detail_3, setDetail_3] = useState([])
  const [detail_4, setDetail_4] = useState([])
  const [detail_5, setDetail_5] = useState([])

  useEffect(() => {
    setDetail_1(step?.result.length > 0 ? step?.result[0].groups : [])
    setDetail_2(step?.result.length > 1 ? step?.result[1].groups : [])
    setDetail_3(step?.result.length > 2 ? step?.result[2].groups : [])
    setDetail_4(step?.result.length > 3 ? step?.result[3].groups : [])
    setDetail_5(step?.result.length > 4 ? step?.result[4].groups : [])
  }, [step?.result])

  return (
    <>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {dataStep.length > 0 && dataStep[0].equip_it_group}
        </div>

        <>
          {detail_1.length > 0 &&
            detail_1
              .sort((a, b) => a.id - b.id)
              .map((d, i) => (
                <Row className="mb-3" key={i}>
                  <Col xl={6}>
                    <Checkbox.Group>
                      <CheckboxCustom className="fw-light">
                        {d.is_detail === 1 ? (
                          <div className="form-check mb-3" key={`${d}-${i}`}>
                            <input
                              readOnly
                              checked={d.is_check === 1 ? true : false}
                              name={`description1`}
                              type="checkbox"
                              id={`inline-checkbox-${i}`}
                              className="form-check-input"
                            />
                            <div className="form-check-label">
                              <label htmlFor={`checkbox-radio-${i}`}>
                                {d.equip_it_name}
                              </label>
                              <div
                                style={{
                                  marginLeft: '35px',
                                  maxWidth: '150px'
                                }}
                              >
                                <Form.Control
                                  disabled={
                                    d.is_check === 1 && d.confirm_date
                                      ? true
                                      : false
                                  }
                                  value={d.detail}
                                  className=""
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Form.Check
                            defaultChecked={d.is_check === 0 ? false : true}
                            label={d.equip_it_name}
                            name={`description1`}
                            type="checkbox"
                            className="mb-3"
                          />
                        )}
                      </CheckboxCustom>
                    </Checkbox.Group>
                  </Col>
                  <Col xl={6}>
                    <div className="d-flex" style={{ columnGap: '16px' }}>
                      <Button
                        size="sm"
                        style={{ minWidth: 120 }}
                        variant="secondary"
                        disabled
                        className="rounded-3"
                      >
                        <BsCheck2 size={18} className="me-1" /> Confirm
                      </Button>
                      <BoxName className="rounded-3">
                        {d.name_th} {d.surname_th}{' '}
                        {d.confirm_date
                          ? moment(d.confirm_date).format('DD/MM/YYYY')
                          : ''}
                      </BoxName>
                    </div>
                  </Col>
                </Row>
              ))}
        </>
      </Col>
      {isComputer !== 0 && (
        <>
          <Col xl={12}>
            <div className="fw-bold mb-2 ">ตั้งค่าเครื่องคอมพิวเตอร์</div>

            {detail_2.length > 0 &&
              detail_2
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <Row className="mb-3" key={`set-com${i}`}>
                    <Col xl={6}>
                      <Checkbox.Group>
                        <CheckboxCustom className="fw-light">
                          {d.is_detail === 1 ? (
                            <div className="form-check mb-3" key={`${d}-${i}`}>
                              <input
                                checked={d.is_check === 1 ? true : false}
                                name={`description1`}
                                type="checkbox"
                                id={`inline-checkbox-${i}`}
                                className="form-check-input"
                              />
                              <div className="form-check-label">
                                <label htmlFor={`checkbox-radio-${i}`}>
                                  {d.equip_it_name}
                                </label>
                                <div
                                  style={{
                                    marginLeft: '35px',
                                    maxWidth: '150px'
                                  }}
                                >
                                  <Form.Control
                                    disabled={
                                      d.is_check === 1 && d.confirm_date
                                        ? true
                                        : false
                                    }
                                    value={d.detail}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            <Form.Check
                              defaultChecked={d.is_check === 0 ? false : true}
                              label={d.equip_it_name}
                              name={`description1`}
                              type="checkbox"
                              className="mb-3"
                            />
                          )}
                        </CheckboxCustom>
                      </Checkbox.Group>
                    </Col>
                    <Col xl={6}>
                      <div className="d-flex" style={{ columnGap: '16px' }}>
                        <Button
                          size="sm"
                          style={{ minWidth: 120 }}
                          variant="secondary"
                          disabled
                          className="rounded-3"
                        >
                          <BsCheck2 size={18} className="me-1" /> Confirm
                        </Button>
                        <BoxName className="rounded-3">
                          {' '}
                          {d.name_th} {d.surname_th}{' '}
                          {d.confirm_date
                            ? moment(d.confirm_date).format('DD/MM/YYYY')
                            : ''}
                        </BoxName>
                      </div>
                    </Col>
                  </Row>
                ))}
          </Col>

          <Col xl={12}>
            <div className="fw-bold mb-2 ">
              {dataStep.length > 2 && dataStep[2].equip_it_group}
            </div>

            <Checkbox.Group>
              <CheckboxCustom className="fw-light">
                {detail_3.length > 0 &&
                  detail_3.map((d, i) => (
                    <Form.Check
                      readOnly
                      checked={d.is_check === 1 ? true : false}
                      key={`set-softwear${i}`}
                      label={d.equip_it_name}
                      name={`description`}
                      type="checkbox"
                      className="mb-3"
                      value={d.id}
                    />
                  ))}
              </CheckboxCustom>
            </Checkbox.Group>
          </Col>
        </>
      )}

      <Col xl={12} className="text-center mt-5 mb-5">
        {dataStep.length > 2 && dataStep[2].approve && (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[2].approve.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[2].approve.title_th} {dataStep[2].approve.name_th}{' '}
                {dataStep[2].approve.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[2].approve.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {moment(dataStep[2].approve.confirm_date).format('DD/MM/YYYY')}
              </div>
            </div>
          </div>
        )}
      </Col>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {dataStep.length > 3 && dataStep[3].equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_4.length > 0 &&
              detail_4
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <div className="form-check mb-3" key={d + i}>
                    <input
                      readOnly
                      checked={d.is_check === 1 ? true : false}
                      name={`group4`}
                      type="checkbox"
                      id={`inline-group4-${i}`}
                      className="form-check-input"
                    />
                    <div className="form-check-label">
                      <label htmlFor={`inline-group4-${i}`}>
                        {d.equip_it_name}
                      </label>
                      {d.is_detail ? (
                        <div style={{ marginLeft: '35px', minWidth: '300px' }}>
                          <Form.Control
                            disabled={dataStep[3].approve}
                            value={d.detail}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      <Col xl={12} className="text-center mt-5 mb-5">
        {dataStep.length > 3 && dataStep[3].approve && (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                <Image width={250} fluid src={dataStep[3].approve.url} />
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({dataStep[3].approve.title_th} {dataStep[3].approve.name_th}{' '}
                {dataStep[3].approve.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {dataStep[3].approve.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {moment(dataStep[3].approve.confirm_date).format('DD/MM/YYYY')}
              </div>
            </div>
          </div>
        )}
      </Col>
      <Col xl={12}>
        <div className="fw-bold mb-2 ">
          {dataStep.length > 4 && dataStep[4].equip_it_group}
        </div>

        <Checkbox.Group>
          <CheckboxCustom className="fw-light">
            {detail_5.length > 0 &&
              detail_5
                .sort((a, b) => a.id - b.id)
                .map((d, i) => (
                  <div className="form-check mb-3" key={`${d}-${i}`}>
                    <input
                      name={`group5`}
                      type="checkbox"
                      id={`inline-checkbox-${i}`}
                      className="form-check-input"
                      readOnly
                      checked={d.is_check === 1 ? true : false}
                    />
                    <div className="form-check-label">
                      <label htmlFor={`checkbox-radio-${i}`}>
                        {d.equip_it_name}
                      </label>
                      <div style={{ marginLeft: '35px' }}>
                        <Form.Control value={d.detail} disabled={approve} />
                      </div>
                    </div>
                  </div>
                ))}
          </CheckboxCustom>
        </Checkbox.Group>
      </Col>
      {dataStep.length > 4 && dataStep[4].approve && (
        <Col
          xl={12}
          className=" mt-5 font-small-2 d-flex justify-content-center"
        >
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              <Image width={250} fluid src={dataStep[4].approve.url} />
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({dataStep[4].approve.title_th} {dataStep[4].approve.name_th}{' '}
              {dataStep[4].approve.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {dataStep[4].approve.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(dataStep[4].approve.confirm_date).format('DD/MM/YYYY')}
            </div>
          </div>
        </Col>
      )}
      {approve && (
        <Col
          xl={12}
          className=" mt-5 font-small-2 d-flex justify-content-center"
        >
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              <Image width={250} fluid src={approve.url} />
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({approve.title_th} {approve.name_th} {approve.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {approve.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(approve.confirm_date2).format('DD/MM/YYYY')}
            </div>
          </div>
        </Col>
      )}
    </>
  )
}

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px !important;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: "var(--comp-badge-color-background-primary)" !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid "var(--comp-badge-color-background-primary)";
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`

const BoxName = styled.div`
  width: 100%;
  font-size: 13px;
  background-color: #e3e3e3;
  border: 1px solid #e6e6e6;
  opacity: 0.5;
  height: 35px;
  padding: 0.375rem 0.75rem;
`
